import { Accordion, AccordionSummary, AccordionDetails, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Divider } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import React from "react"
import { DataGrid } from "@mui/x-data-grid"

function ReconciliationTable({ maxHeight, isAccordion = true, title, rows, columns, tableKey, handleRowClick, isExpanded = false, getRowClassName, tableStyle, headerRowColor, headerRowBg }) {
  const CustomTable = () => {
    return (
      <DataGrid
        rows={rows}
        columns={columns}
        density={"compact"}
        {...(tableKey
          ? {
              getRowId: (row) => tableKey.map((_k) => row[_k]).join("-"),
            }
          : {})}
        // getRowId={(row) => tableKey.map((_k) => row[_k]).join("-")}
        getRowClassName={(params) => {
          if (getRowClassName) {
            return getRowClassName(params.row)
          }
          return ""
        }}
        // initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 50, 100]}
        // style={tableStyle ? { ...tableStyle } : {}}
        // style={{ borderTopLeftRadius: "0px" }}
        // checkboxSelection
        sx={{
          // background: "var(--va-card-3)",
          // background: "#f5f6fc",
          background: "#e8eaf9",
          color: "#2c2c54",
          height: maxHeight,
          maxHeight: maxHeight || "100%",

          "& .MuiDataGrid-columnHeaderRow": {
            backgroundColor: headerRowBg ? headerRowBg : "#b5b3ff", // match your background
            color: headerRowColor ? headerRowColor : "var(--va-primary-color)",
          },

          "& .MuiDataGrid-columnHeaders div": {
            backgroundColor: headerRowBg ? headerRowBg : "#b5b3ff", // match your background
            color: headerRowColor ? headerRowColor : "var(--va-primary-color)",
          },

          "& .MuiDataGrid-columnHeaders .MuiDataGrid-filler": {
            backgroundColor: headerRowBg ? headerRowBg : "#b5b3ff", // match your background
            color: headerRowColor ? headerRowColor : "var(--va-primary-color)",
          },

          // "& .MuiDataGrid-footerContainer": {
          //   backgroundColor: "var(--va-card-4)", // match your background
          // },
          "& .sticky-column": {
            position: "sticky !important",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 99,
            borderRight: "1px solid #ccc",
          },
          "& .sticky-header": {
            position: "sticky !important",
            left: 0,
            zIndex: 99,
            backgroundColor: "#f5f5f5",
          },

          "& .MuiDataGrid-row:hover": {
              background: "rgba(84,104,255,0.08)",
              transform: "scale(1.01)",
              transition: "all 0.2s ease",
            },
          ...(tableStyle || {}),
        }}
        rowHeight={50}
      />
    )
  }

  return isAccordion ? (
    <>
      <Accordion defaultExpanded={isExpanded} sx={{ background: "rgba(0,0,0,0.5)" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginRight: "20px",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ color: "white", flex: "1" }}>
              {title}
            </Typography>

            <Typography variant="body" sx={{ color: "white" }}>
              Total Transactions: <span style={{ color: "black", fontWeight: "bold" }}> {rows.length} </span>
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <CustomTable />
        </AccordionDetails>
      </Accordion>

      <Divider sx={{ marginY: 4 }} />
    </>
  ) : (
    <CustomTable />
  )

  // <div style={{marginBottom:"20px"}}>
  //   <CustomTable />
  // </div>
}

export default React.memo(ReconciliationTable, (prevProps, nextProps) => {
  return prevProps.rows === nextProps.rows && prevProps.columns === nextProps.columns && prevProps.tableKey === nextProps.tableKey && prevProps.isAccordion === nextProps.isAccordion
})

// export default AppealsTable;
